const faqs = [
  {
    id: 1,
    question: '今日吃瓜的内容来源是什么？',
    answer: '我们的内容团队每天从微博、抖音、小红书、B站、豆瓣等20多个主流社交平台实时筛选和整理热点事件。所有信息均来自公开渠道，我们会交叉验证信息来源的可靠性，确保为大家呈现真实、准确的吃瓜内容。对于来源不明或未经证实的信息，我们会在发布时明确标注。',
  },
  {
    id: 2,
    question: '更新频率是怎样的？',
    answer: '今日吃瓜保持每日高频更新。快讯模块全天滚动刷新，专题内容每日更新3-5篇，热门大瓜汇总每天至少更新一次。热点榜单根据实时热度动态调整，你在任何时间打开都能看到最新的吃瓜内容。每天睡前查看「每日必吃」精华汇总已经成为很多瓜友的习惯。',
  },
  {
    id: 3,
    question: '如何给今日吃瓜投稿爆料？',
    answer: '我们非常欢迎瓜友们提供线索和爆料！你可以通过页面上的「投稿爆料」入口提交信息，也可以在评论区留言。如果你有独家爆料或深度线索，请尽可能提供详细信息和可核实的证据，我们的编辑团队会认真评估每一条投稿，有价值的线索将获得优先处理和发布。',
  },
  {
    id: 4,
    question: '今日吃瓜有移动端吗？',
    answer: '目前你可以通过关注我们的公众号在移动端阅读今日吃瓜内容，随时随地掌握最新大瓜动态。公众号每日推送精选内容汇总，让你不错过任何一个热点。我们也在持续优化移动端阅读体验，未来会有更多便捷的访问方式，敬请期待。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            ❓ 常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于今日吃瓜，你可能想了解这些
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="rounded-xl bg-background-100 border border-background-200/70 p-5"
            >
              <h3 className="text-base font-heading text-foreground-800 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {faq.question}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-7">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}